import { getTTL } from "@views/users/list/common-utils";

const getMostRecentCodeByKey = (values) => {
  return Object.entries(values).reduce((acc, [key, codes]) => {
    const mostRecent = codes.toSorted(
      (a, b) => new Date(b.expiry).getTime() - new Date(a.expiry).getTime()
    )[0];

    const code = {
      code: mostRecent.code,
      ttl: getTTL(mostRecent.expiry),
      expiry: mostRecent.expiry,
      simulationId: mostRecent.simulationId,
    };

    if (code.ttl > 0) {
      acc[key] = code;
    }
    return acc;
  }, {});
};

export const filterClassroomLoginCodesByUserId = (codes, userId) => {
  const codesByUserId = codes.reduce((acc, code) => {
    if (!code.simulationId) {
      const userCodes = acc[code.userId] ?? [];
      userCodes.push(code);
      acc[code.userId] = userCodes;
    }

    return acc;
  }, {});

  const mostRecentCodesByUserId = getMostRecentCodeByKey(codesByUserId);

  if (userId) {
    return mostRecentCodesByUserId[userId];
  }
  return mostRecentCodesByUserId;
};

export const filterUserLoginCodesByLEId = (
  codes,
  userId,
  learningExperienceId
) => {
  const codesByUserId = codes.reduce((acc, code) => {
    if (code.simulationId) {
      const userCodes = acc[code.userId] ?? {};
      const simulationCodes = userCodes[code.simulationId] ?? [];
      simulationCodes.push(code);
      userCodes[code.simulationId] = simulationCodes;
      acc[code.userId] = userCodes;
    }

    return acc;
  }, {});

  const mostRecentCodesByLEId = Object.entries(codesByUserId).reduce(
    (acc, [userId, userCodes]) => {
      acc[userId] = getMostRecentCodeByKey(userCodes);
      return acc;
    },
    {}
  );

  if (learningExperienceId && userId) {
    return mostRecentCodesByLEId[userId]?.[learningExperienceId];
  } else if (userId) {
    return mostRecentCodesByLEId[userId];
  }
  return mostRecentCodesByLEId;
};

/**
 * Groups a user's unexpired sim-specific codes by simulation, keeping the most
 * recent code per category. TS sim passes are issued one code per category, so
 * the result maps `learningExperienceId -> { [categoryCode]: code }`.
 */
export const filterUserSimCodesByCategory = (codes, userId) => {
  const codesBySimAndCategory = codes.reduce((acc, code) => {
    if (code.userId === userId && code.simulationId && code.categoryCode) {
      const simCodes = acc[code.simulationId] ?? {};
      const categoryCodes = simCodes[code.categoryCode] ?? [];
      categoryCodes.push(code);
      simCodes[code.categoryCode] = categoryCodes;
      acc[code.simulationId] = simCodes;
    }

    return acc;
  }, {});

  return Object.entries(codesBySimAndCategory).reduce(
    (acc, [simulationId, simCodes]) => {
      const mostRecentByCategory = getMostRecentCodeByKey(simCodes);
      if (Object.keys(mostRecentByCategory).length > 0) {
        acc[simulationId] = mostRecentByCategory;
      }
      return acc;
    },
    {}
  );
};
